import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';

import './SyncFileDropzone.css';

/**
 * Dashed drag-and-drop zone for Synchronisation panel file importers.
 * Click opens the file picker; parent validates and handles the File.
 *
 * @param {{
 *   accept?: string,
 *   disabled?: boolean,
 *   fileName?: string,
 *   hint?: string,
 *   onFile: (file: File) => void,
 *   className?: string,
 * }} props
 */
const SyncFileDropzone = ({
    accept,
    disabled = false,
    fileName,
    hint,
    onFile,
    className,
}) => {
    const { t } = useTranslation();

    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles?.[0];
        if (file && onFile)
            onFile(file);
    }, [onFile]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple: false,
        disabled,
        noKeyboard: false,
    });

    const rootClass = [
        'SyncFileDropzone',
        isDragActive ? 'SyncFileDropzone--active' : '',
        disabled ? 'SyncFileDropzone--disabled' : '',
        className || '',
    ].filter(Boolean).join(' ');

    return (
        <div {...getRootProps({ className: rootClass })}>
            <input {...getInputProps({ accept })} />
            <p>{ hint || t('common.drag_one_file') }</p>
            {fileName ? (
                <div className="SyncFileDropzone-fileName mt-2">
                    <i className="fa fa-file-o" aria-hidden="true" />
                    &nbsp;<b>{ fileName }</b>
                </div>
            ) : null}
        </div>
    );
};

export default SyncFileDropzone;
